import { useState, useEffect, useMemo } from 'react';
import _pick from 'lodash/pick';
/**
 * Return sash data for a given array of product tags
 * @param {string[]} tags - an array of product tags from Shopify
 */
export const useSash = (tags) => {
  const [sashData, setSashData] = useState(window.Shopify?.sashData);

  useEffect(() => {
    const updateSashData = () => setSashData(window.Shopify?.sashData);
    if (!sashData) {
      window.addEventListener('sashReady', updateSashData);
    }
    return () => {
      window.removeEventListener('sashReady', updateSashData);
    };
  }, [sashData]);

  return useMemo(
    () => Object.values(_pick(sashData, tags))
      .filter(({ excludeTags }) => !excludeTags || !excludeTags.some((excludedTag) => tags.includes(excludedTag)))
      .sort(({ sortOrder: a }, { sortOrder: b }) => a - b)
      .reduceRight(
        (acc, cur) => {
          if (cur.pdpSash) {
            acc.pdpSash.unshift(cur.pdpSash);
          }
          if (cur.topSash?.label) {
            acc.topSash = cur.topSash;
          }
          if (cur.bottomSash?.label) {
            acc.bottomSash = cur.bottomSash;
          }
          if (cur.saleSash) {
            acc.saleSash = cur.saleSash;
          }
          return acc;
        },
        {
          pdpSash: []
        }
      ),
    [tags, sashData]
  );
};
